import { render } from "./HomePageArticle.vue?vue&type=template&id=8f4d9296&scoped=true"
const script = {}

import "../assets/css/homepagearticle.css?vue&type=style&index=0&id=8f4d9296&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f4d9296"]])

export default __exports__